export default "__VITE_ASSET__DMf3GKsm__"